import { formatDate, NgIf, NgFor } from '@angular/common';
import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output } from '@angular/core';
import { DateFormatPipe } from '../../extensions/datePipe';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

import { MatIconModule } from '@angular/material/icon';
import { TooltipDirective } from '@/directives/tooltip/tooltip.directive';

export class TimelineIcon {
  matIcon: string;
  tooltip: string;
}
export class TimelineEvent {
  eventId: string;
  date: string;
  title: string;
  details: string;
  svgIcon?: string;
  matIcon?: string;

  leftIcons?: TimelineIcon[] = [];

  canUpdate = false;
  canDelete = false;
}

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, MatIconModule, MatButtonModule, MatMenuModule, DateFormatPipe, TooltipDirective]
})
export class TimelineComponent implements OnInit {
  @Input() events: TimelineEvent[];
  @Output() updateTriggered = new EventEmitter<string>();
  @Output() deleteTriggered = new EventEmitter<string>();

  years: string[] = [];
  eventsByYears: { [key: number]: TimelineEvent[] } = {};

  constructor(@Inject(LOCALE_ID) public locale: string) {}

  ngOnInit(): void {
    this.events.forEach((event) => {
      const year = formatDate(event.date, 'yyyy', this.locale);
      if (!this.eventsByYears[year]) {
        this.eventsByYears[year] = [];
        this.years.push(year);
      }
      this.eventsByYears[year].push(event);
    });
  }

  getEventCardClass(event): string {
    const index = this.events.indexOf(event) + 1;
    let cardClass = 'timeline-card';
    cardClass += index % 2 === 0 ? ' even' : ' odd';
    return cardClass;
  }

  getEvents(year: number): TimelineEvent[] {
    return this.eventsByYears[year];
  }

  triggerUpdate(event: TimelineEvent) {
    this.updateTriggered.emit(event.eventId);
  }

  triggerDelete(event: TimelineEvent) {
    this.deleteTriggered.emit(event.eventId);
  }
}
